import React from 'react';

import cx from 'classnames';

import SAFARI_PORTAL_LOGO from 'components/shared/images/safari_portal.svg';
import styles from 'components/shared/LandingPage/blocks/PageHeader/index.module.css';
import Text from 'components/shared/Typography/Text';

import { useLandingV2Context } from '../../context';
import { getPrefix } from '../../utils';
import s from './index.module.css';

const TopBar = () => {
  const { data, rightActions, leftActions, config } = useLandingV2Context();

  const renderLogo = () => {
    if (!data.brandSettings?.logo?.url && data.brandSettings?.companyName) {
      return (
        <Text hoefler italic className={cx(s.companyName, getPrefix('right-header-companyname'))}>
          {data.brandSettings?.companyName}
        </Text>
      );
    }
    return (
      <img
        src={data.brandSettings?.logo?.url || SAFARI_PORTAL_LOGO}
        alt="logo"
        className={getPrefix('right-header-logo')}
        crossOrigin=""
      />
    );
  };
  const leftActionsAvailable = config.header && !!config.header.topBar && config.header.topBar.leftActions;

  return (
    <div className={cx(getPrefix('top-bar'), s.topBar)}>
      {/*@ts-ignore*/}
      <div>{leftActionsAvailable ? leftActions : null}</div>
      <div className={cx(styles.headerLogo, getPrefix('right-header-logo'))}>{renderLogo()}</div>
      <div>{rightActions}</div>
    </div>
  );
};

export default TopBar;
